// @theme component
import * as Types from './types';
import { actionTypes } from './constants';

export * from '@core/js/components/main/GamesGrid/store/actions';

export const setPragmaticTableData = (message: Types.IPragmaticMessageData): Types.IPragmaticSetTableData => ({
    type: actionTypes.PRAGMATIC_SET_TABLE_DATA,
    payload: message
});
